import { getButtonFocusOverrideStyle } from './common-styles';

export const getMenuItemStyles = (menuItem, { palette = {} }) => ({
  baseMenuItem: {
    height: 36,
    fontFamily: 'Segoe UI',
    fontWeight: 'normal',
    lineHeight: 'normal',
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
    border: 0,
    textDecoration: 'none',
    alignItems: 'baseline',
    width: 227,
    textAlign: 'left',
    minWidth: '1px',
    borderRadius: 'unset',
    // menu item is using Button, but states' style should not act the same as Button.
    '& a': {
      color: palette.white,
    },
    '&:focus': getButtonFocusOverrideStyle(palette.neutralSecondary),
    '&:active': {
      '&:focus': {
        '&:after': {
          border: 0,
        },
      },
    },
    '& .spinner_label': {
      color: palette.white,
    },
    '&.main-menu-campaign-type': {
      height: 'auto',
    },
  },
  collapsedMenuItem: {
    width: '100%',
  },
  normalMenuItem: {
    backgroundColor: `${palette.neutralPrimaryAlt} !important`,
    '&:focus': {
      backgroundColor: palette.mainMenuHoverBackground,
    },
    '&:hover': {
      backgroundColor: `${palette.mainMenuHoverBackground} !important`,
    },
  },
  selectedMenuItem: {
    fontWeight: 600,
    backgroundColor: '#323031 !important',
  },
  menuItemAnchor: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: 20,
    marginTop: 3,
  },
  selectedNode: {
    paddingRight: 16,
  },
  beforeIcon: {
    borderLeft: `4px solid ${palette.themePrimary}`,
    padding: 0,
    marginRight: -4,
    alignSelf: 'stretch',
  },
  iconContainer: {
    display: 'inline-block',
    marginLeft: 16,
    marginTop: 10,
    marginBottom: 10,
    marginRight: 12,
    width: 16,
    height: 16,
    fontSize: 16,
    color: palette.white,
    '&.type-icon': {
      alignSelf: 'center',
    },
  },
  textContainer: {
    overflow: 'hidden',
    marginTop: 8,
    marginBottom: 9,
    textOverflow: 'ellipsis',
    flex: '1 1 1px',
    whiteSpace: 'nowrap',
    fontSize: 14,
    color: palette.white,
    paddingRight: 20,
    overflowWrap: 'break-word',
    '&.type-name': {
      whiteSpace: 'normal',
    },
  },
  typeSelectionIcon: {
    fontSize: 16,
    display: 'block',
    margin: '0px !important',
    top: '0px !important',
  },
  placeholderTextContainer: {
    marginLeft: 22,
  },
});

